import Vue from 'vue'
import Router from 'vue-router'
import {
  setTit,
  getQueryString
} from '@/libs/util'
// import {
//   asyncRouterMap
// } from "./router/routers"
// import routerList from "./router/routers"
import routerList from "./router/routers"

Vue.use(Router)

// 解决重复点击路由报错的BUG
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
let list = routerList

console.log(routerList, 'routerList')

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: list
})


router.beforeEach((to, from, next) => {
  let ua = navigator.userAgent.toLocaleLowerCase()
  let list = ua.split(' ');
  let appId = ''
  for (let i = 0; i < list.length; i++) {
    if (list[i].match(/appid/) || list[i].match(/appId/)) {
      appId = list[i].slice(6)
    }
  }

  if (appId != '') {
    sessionStorage.setItem('appId', appId)
    localStorage.setItem('appId', appId)
  }


  let userData = localStorage.getItem('userUnifyToken')
  let authorizeUrl = ''
  // 不需要拦截页面 todo

  if (appId != '') {
    next()
  } else {
    if (to.meta.name == "login" || to.meta.name == "help" || to.meta.name == "loginout") {
      // if (userData) {
      //   // 判断是否登录如登录放行
      //   next()
      // } else {
      //   next({
      //     path: "/login",
      //   })
      // }
      // 判断是否登录如登录放行
      console.log(1)
      next()
    } else {
      // 不是去登录页的话
      if (userData) {
        // 判断是否登录如登录放行
        next()

      } else {
        console.log(getQueryString('authorizeUrl'), '33333')

        if (getQueryString('authorizeUrl')) {
          authorizeUrl = getQueryString('authorizeUrl')
          // 未登录去登录页
          next({
            path: "/login",
            query: {
              authorizeUrl: authorizeUrl
            } // 将原始目标路径作为查询参数传递
          })
        } else {
          console.log(4)
          // 未登录去登录页
          next({
            path: "/login",
          })
        }

      }

    }
  }


})


export default router